import { configureStore } from '@reduxjs/toolkit';
import languageReducer from '../reducers/language';

export const store = configureStore({
  reducer: {
    language: languageReducer,
  },
});
